<form [formGroup]="form" class="amount-label-container">
  <div [class]="isAdjustable ? 'adjustable-amount-container' : 'unadjustable-amount-container'" [ngClass]="{ 'amount-invalid': errorState }">
    <label for="wholeAmount">Bedrag</label>

    <div [class]="isAdjustable ? 'adjustable-amount' : 'unadjustable-amount'">
      <input
        id="wholeAmount"
        class="amount"
        type="text"
        inputmode="decimal"
        formControlName="amount"
        autocomplete="off"
        pbCurrencyFormatter
        currencyCode="EUR"
        (focus)="onAmountFocus($event)"
        [readOnly]="!isAdjustable"
        (beforeinput)="onWholeAmountBeforeInput($event)"
        />
      @if (!isAdjustable) {
        <div class="amount-overlay-wrapper">
          <div class="integer-overlay">{{ integerPart }}</div>
          <div class="fractional-overlay">{{ fractionalPart }}</div>
        </div>
      }
    </div>
  </div>
  @if (errorState) {
    <div class="error-description">
      <img src="assets/images/error.svg" alt="Error" width="16px" height="16px" />
      @if (form.controls.amount.errors?.['min']) {
        Vul een bedrag in van minimaal € 0,01.
      }
      @if (form.controls.amount.errors?.['max']) {
        Vul een bedrag in van maximaal € {{ this.maxWholeAmount }}.
      }
    </div>
  }
  @if (isAdjustable) {
    <div class="hint">Je kunt het bedrag wijzigen.</div>
  }
</form>
